import {AuthConfigActions, AuthConfigReducer, ApiConfigActions, MicrosoftApiConfigActions, GraphQlConfigActions, RoleModels} from "@pwbapps/reduxcore";
import {CommandActions, DocumentActions, FETCH_PROJECT_ROLES, GET_STAKEHOLDER_ID} from "../../actions/initialization";
import {CommandActions as LoaderCommandActions} from "../../actions/loader";
import {CommandActions as SharedDataCommandActions} from "../../actions/sharedData";
import { getCloseFiltersPanel, getHistoryName } from "../../../utils/functions";
import _ from "lodash";
import { DocumentActions as UiDocumentActions, CommandActions as UiCommandActions } from "../../actions/ui";
import { InternalRoleActionsType, InternalRolesType, ExternalRolesType, ExternalRoleActionsType, InternalRoleActionsValues, isExternalApp} from "../../../utils/costants";
import { configuration } from '../../../configuration';
import { MeProjectRoles, getProjectRoleCodes, isInternalSuperAdmin } from '../../../models/projectRoles';
import { getSelectedProjectId } from '../../reducers/project';
import { DocumentActions as ProjectDocumentActions } from '../../actions/project';
import { DocumentActions as NotificationDocumentActions } from '../../actions/notification';
import { MessageBarType } from '@fluentui/react';

let rolesRequestId = 0;

export const initializationMiddlewareHistory = (history: any) => {
    return initializationMiddleware(history);
}

export const initializationMiddleware = (history: any) => ({dispatch, getState}: {dispatch: any, getState: any}) => (next: any) => (action: CommandActions | AuthConfigActions.Actions | ApiConfigActions.EventActions | MicrosoftApiConfigActions.EventActions | GraphQlConfigActions.EventActions) => {
    next(action);
    switch (action.type) {

        case AuthConfigActions.LOGIN_COMPLETED:
            const {account} = action.payload;
            if(account){
                dispatch(CommandActions.fetchProjectRoles({bootstrap: true}));
            }   
            break;

        case FETCH_PROJECT_ROLES:
            next(AuthConfigActions.DocumentActions.setRoles({roles: []}));
            next(DocumentActions.setValue({name: 'projectRoles', value: undefined}));
            next(DocumentActions.setValue({name: 'company', value: undefined}));
            next(DocumentActions.setValue({name: 'stakeHolderId', value: undefined}));
            next(DocumentActions.setValue({name: 'rolesLoading', value: true}));
            next(DocumentActions.setValue({name: 'rolesError', value: undefined}));
            dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: {
                method: 'GET', url: `${configuration.api_endpoint}/Me/ProjectRoles`, feature: FETCH_PROJECT_ROLES,
                returnObject: {...action.payload, requestId: ++rolesRequestId}
            }}));
            break;

        case AuthConfigActions.LOGOUT:
            rolesRequestId++;
            next(AuthConfigActions.DocumentActions.setRoles({roles: []}));
            ['projectRoles', 'company', 'stakeHolderId', 'rolesError'].forEach(name => next(DocumentActions.setValue({name, value: undefined})));
            next(DocumentActions.setValue({name: 'rolesLoading', value: false}));
            break;

        case ApiConfigActions.API_SUCCESS:
            apiSuccessMiddleware(history, dispatch, getState, next, action);         
            break;
    
        case ApiConfigActions.API_ERROR:
            apiErrorMiddleware(history, dispatch, getState, next, action);         
            break;

        default:
            break;
    }
};

const apiSuccessMiddleware = (history: any, dispatch: any, getState: any, next: any, action: ApiConfigActions.ApiSuccessAction) => {
    switch(action.meta.feature) {

        case FETCH_PROJECT_ROLES: {
            if (action.meta.returnObject.requestId !== rolesRequestId) break;
            const me = action.payload as MeProjectRoles;
            if (!me || !['internal', 'external'].includes(me.tenant) || !Array.isArray(me.projects)) {
                apiErrorMiddleware(history, dispatch, getState, next, {...action, payload: {detail: 'Invalid project roles response'}} as any);
                break;
            }
            const roles: RoleModels.Role[] = [];
            me.projects.forEach(project => getProjectRoleCodes(me, project.projectId).forEach(code => {
                const role = me.tenant === 'internal' ? getInternalRole(code) : getExternalRole(code);
                roles.push({...role, name: `${project.projectId}:${code}`});
            }));
            if (isInternalSuperAdmin(me)) roles.push(getInternalRole('SUPERADMIN'));
            next(DocumentActions.setValue({name: 'projectRoles', value: me}));
            next(DocumentActions.setValue({name: 'rolesLoading', value: false}));
            next(AuthConfigActions.DocumentActions.setRoles({roles}));
            const account = AuthConfigReducer.getAccount(getState());
            const claims = account && account.idTokenClaims as any;
            if (isExternalApp && me.tenant === 'external' && claims && typeof claims.company === 'string') {
                next(CommandActions.setCompany({value: claims.company}));
            }
            const selectedProjectId = getSelectedProjectId(getState());
            const allowed = isInternalSuperAdmin(me) || getProjectRoleCodes(me, selectedProjectId).length > 0;
            if (!allowed) {
                next(ProjectDocumentActions.setSelectedProjectId({id: undefined}));
                dispatch(LoaderCommandActions.setLoading({feature: getHistoryName(history), loading: false}));
            }
            if (action.meta.returnObject.bootstrap) initializeLandingPage(dispatch, next, getState, history);
            else if (action.meta.returnObject.projectId && allowed) {
                const historyName = getHistoryName(history);
                dispatch(SharedDataCommandActions.getProjectSharedDataAndLoadObjects({fetchObjects: historyName !== 'landing' && historyName !== 'home'}));
                if (historyName === 'landing' || historyName === 'home') dispatch(UiCommandActions.changeDrawerPage({key: '/home'}));
            }
            break;
        }

        case GET_STAKEHOLDER_ID: {
            let stakeholder = (action.payload && action.payload.value && action.payload.value.length > 0) ? action.payload.value[0] : undefined
            if(stakeholder)
                next(CommandActions.setStakeHolderId({value: stakeholder.stakeHolderId}));
            break;
        }
    }
}

const apiErrorMiddleware = (history: any, dispatch: any, getState: any, next: any, action: ApiConfigActions.ApiErrorAction) => {
    switch(action.meta.feature) {
        case FETCH_PROJECT_ROLES: {
            if (action.meta.returnObject.requestId !== rolesRequestId) break;
            const message = 'Cannot load project permissions. Please refresh the page.';
            next(DocumentActions.setValue({name: 'projectRoles', value: undefined}));
            next(DocumentActions.setValue({name: 'rolesLoading', value: false}));
            next(DocumentActions.setValue({name: 'rolesError', value: message}));
            next(AuthConfigActions.DocumentActions.setRoles({roles: []}));
            next(ProjectDocumentActions.setSelectedProjectId({id: undefined}));
            dispatch(LoaderCommandActions.setLoading({feature: getHistoryName(history), loading: false}));
            next(NotificationDocumentActions.setNotificationStatus({name: getHistoryName(history), show: true, type: MessageBarType.error, message}));
            break;
        }
        case GET_STAKEHOLDER_ID: {
           
            break;
        }
    }
}

const getInternalRole = (name: string): RoleModels.Role => {
    let role: RoleModels.Role = {name: '', actions: []};
    let roleName = name as InternalRolesType;
    let actions: InternalRoleActionsType[] = [];
    if(roleName){
        role.name = name;
        switch(roleName) {
            case 'SUPERADMIN': {
                actions = [...InternalRoleActionsValues];
                break;
            }
            case 'ADMINISTRATOR': {
                actions = ['Enable', 'ShowHome', 'ShowFolders', 'CreateFolders', 'ShowDashboard', 'ReadDashboard', 'DeleteDashboard', 'EditDashboard', 'ChangeStatusDashboard', 'UploadAttachmentDashboard', 'UploadCommentFileDashboard', 'InsertTextCommentDashboard',
                           'ShowQualityCheck', 'ReadQualityCheck', 'DeleteQualityCheck', 'EditQualityCheck', 'UploadAttachmentQualityCheck', 'UploadCommentFileQualityCheck', 'InsertTextCommentQualityCheck', 'ReadyForPublishQualityCheck',
                           'ShowPublish', 'ReadPublish', 'DeletePublish', 'EditPublish', 'UploadAttachmentPublish', 'UploadCommentFilePublish', 'InsertTextCommentPublish', 'PublishPublish',
                           'ShowPending', 'ReadPending', 'ApprovePending', 'DeclinePending', 'UploadAttachmentPending', 'UploadCommentFilePending', 'InsertTextCommentPending',
                           'ShowReservedNumbers', 'ReadReservedNumbers', 'InsertTextCommentReservedNumbers', 'NewSheetReservedNumbers', 'NewRevisionReservedNumbers', 'SelectFileTypeReservedNumbers', 'GenerateNumberAndPartReservedNumbers',
                           'ShowSupplierMaterial', 'ReadSupplierMaterial', 'InsertTextCommentSupplierMaterial', 'PublishSupplierMaterial', 'DeclineSupplierMaterial',
                           'ShowCreateRevision', 'ReadCreateRevision', 'ShowClientNumber', 'InsertTextCommentCreateRevision'
                           ];
                break;
            }
            case 'PUBLISHER': {
                actions = ['ShowHome','ShowFolders', 'ShowDashboard', 'ReadDashboard', 'UploadAttachmentDashboard', 'UploadCommentFileDashboard', 'InsertTextCommentDashboard',
                           'ShowQualityCheck', 'ReadQualityCheck', 'ReadyForPublishQualityCheck',
                           'ShowPublish', 'ReadPublish', 'InsertTextCommentPublish', 'PublishPublish'];
                break;
            }
            case 'EEOHANDLER': {
                actions = ['ShowHome', 'ShowFolders', 'ShowDashboard', 'ReadDashboard', 'InsertTextCommentDashboard',
                           'ShowReservedNumbers', 'ReadReservedNumbers', 'NewSheetReservedNumbers', 'NewRevisionReservedNumbers', 'InsertTextCommentReservedNumbers', 'SelectFileTypeReservedNumbers', 'GenerateNumberAndPartReservedNumbers',
                           'ShowSupplierMaterial', 'ReadSupplierMaterial', 'InsertTextCommentSupplierMaterial', 'PublishSupplierMaterial', 'DeclineSupplierMaterial',
                           'ShowCreateRevision', 'ReadCreateRevision', 'InsertTextCommentCreateRevision'];
                break;
            }
            case 'READER': {
                actions = ['ShowHome','ShowFolders', 'ShowDashboard', 'ReadDashboard'];
                break;
            }
            default : {
                role.actions = [];
                break;
            }
        }
        role.actions = actions;
    }
    return role;
}

const getExternalRole = (name: string): RoleModels.Role => {
    let role: RoleModels.Role = {name: '', actions: []};
    let roleName = name as ExternalRolesType;
    let actions: ExternalRoleActionsType[] = [];
    if(roleName){
        role.name = name;
        switch(roleName) {
            case 'SUPPLIER': {
                actions = ['ShowReservedNumbers', 'ReadReservedNumbers', 'UploadParentReservedNumbers', 'NewSheetReservedNumbers', 'SelectFileTypeReservedNumbers',
                           'ShowPublishMaterial', 'ReadPublishMaterial', 'PublishPublishMaterial', 'DeclinePublishMaterial',
                           'FilterDocumentsBySupplierCompany' ];
                break;
            }
            case 'APPROVER': {
                actions = ['ShowHome', 'ShowFolders', 'ShowDashboard', 'ReadDashboard', 'UploadCommentFileDashboard', 'InsertTextCommentDashboard',
                           'ShowPending', 'ReadPending', 'ApprovePending', 'DeclinePending', 'UploadCommentFilePending', 'InsertTextCommentPending',
                            'FilterDocumentsByCustomerId' ];
                break;
            }
            case 'READER': {
                actions = ['ShowHome', 'ShowFolders', 'ShowDashboard', 'ReadDashboard', 'FilterDocumentsByCustomerId'];
                break;
            }
            default : {
                role.actions = [];
                break;
            }
        }
        role.actions = actions;
    }
    return role;
}


const initializeLandingPage = (dispatch: any, next: any, getState: any, history: any) => {
    let historyName = getHistoryName(history);
    next(UiDocumentActions.setDrawerKey({key: history.location.pathname}));
    const closePanel = getCloseFiltersPanel(historyName);
    next(UiDocumentActions.setFilterPanelOpened({open: closePanel ? false : true}));
    if(historyName !== 'landing')
        dispatch(LoaderCommandActions.setLoading({ feature: historyName, loading: true}));
    next(SharedDataCommandActions.getSharedDataAndLoadProjects());
}